import { createContext } from 'react';

const defaultContextValue = {
  data: {
    amount: '',
    applicationOpen: false,
    inn: '',
    phone: '',
    full_name: '',
    email: '',
    promo_code: '',
    term: '',
    advance_rate: ''
  },
  setAmount: (amnt) => {},
  setTerm: (term) => {},
  setAdvanceRate: (advanceRate) => {},
  setApplicationOpen: (isOpen) => {},
};

const ApplicationContext = createContext(defaultContextValue);

export default ApplicationContext;
